import { render } from "./Faq.vue?vue&type=template&id=df5dec96"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
script.render = render

export default script